/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Language_En_UsInputs */

const en_us2_profile_language_en_us = /** @type {(inputs: Profile_Language_En_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const pt_br2_profile_language_en_us = /** @type {(inputs: Profile_Language_En_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const es_419_profile_language_en_us = /** @type {(inputs: Profile_Language_En_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const pt_pt2_profile_language_en_us = /** @type {(inputs: Profile_Language_En_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const fr_fr2_profile_language_en_us = /** @type {(inputs: Profile_Language_En_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de_de2_profile_language_en_us = /** @type {(inputs: Profile_Language_En_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const it_it2_profile_language_en_us = /** @type {(inputs: Profile_Language_En_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {Profile_Language_En_UsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_language_en_us = /** @type {((inputs?: Profile_Language_En_UsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Language_En_UsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_language_en_us(inputs)
	if (locale === "es-419") return es_419_profile_language_en_us(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_language_en_us(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_language_en_us(inputs)
	if (locale === "de-DE") return de_de2_profile_language_en_us(inputs)
	if (locale === "it-IT") return it_it2_profile_language_en_us(inputs)
	return en_us2_profile_language_en_us(inputs)
});
export { profile_language_en_us as "profile.language_en_us" }